export function parsePrimitiveFromString(
  input: string,
): string | number | boolean | null {
  // Try parsing the input as JSON
  try {
    const parsedValue = JSON.parse(input);

    // Check if the parsed value is a primitive type
    if (
      typeof parsedValue === 'string' ||
      typeof parsedValue === 'number' ||
      typeof parsedValue === 'boolean' ||
      parsedValue === null
    ) {
      return parsedValue;
    }
  } catch (_error) {
    // If parsing as JSON fails, handle it below
  }

  // If parsing as JSON fails or the parsed value is not a primitive type,
  // treat the input as a string and add quotes if necessary
  if (input === 'null') {
    return null;
  } else if (input === 'true' || input === 'false') {
    return input === 'true';
  } else if (!isNaN(parseFloat(input))) {
    return parseFloat(input);
  } else {
    return `"${input}"`;
  }
}